// extracted by css-extract-rspack-plugin
export default {"row":"ProductVariantFeedbackCell_row__yP4CZ","count":"ProductVariantFeedbackCell_count__ZIVE_"};